/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const submissionThankYouScreenDataSchema = z.object({
	candidateId: z.string().nullable(),
	sendsConfirmationEmail: z.boolean().default(false),
	whatsappAiFollowUp: z.boolean().default(false),
	candidateProfileEnabled: z.boolean().default(false),
	collectsCv: z.boolean().default(false),
	id: z.string(),
	formId: z.string(),
	minScoreRange: z.number(),
	maxScoreRange: z.number(),
	title: z.string(),
	description: z.string(),
	organisationName: z.string().nullable(),
	logo: z.object({
		id: z.string(),
		name: z.string(),
		fileName: z.string(),
		category: z.union([z.literal('image'), z.literal('file')]),
		mimeType: z.string().nullable(),
		size: z.number(),
		humanReadableSize: z.string(),
		url: z.string(),
		collectionName: z.union([
			z.literal('ad-asset'),
			z.literal('baked-story'),
			z.literal('baked-feed'),
			z.literal('story'),
			z.literal('feed'),
			z.literal('landing-page'),
			z.literal('logo'),
			z.literal('generated'),
			z.literal('uploaded'),
			z.literal('imported'),
			z.literal('candidate-files'),
			z.literal('custom-font'),
			z.literal('design'),
			z.literal('whatsapp-profile'),
		]),
		width: z.number(),
		height: z.number(),
		isPlaceholder: z.boolean(),
		isGenerating: z.boolean(),
		createdAt: z.iso.datetime(),
		isGenerated: z.boolean().default(false),
		startedGenerationAt: z.iso.datetime().nullable(),
		finishedGenerationAt: z.iso.datetime().nullable(),
		meta: z.record(z.string(), z.unknown()).nullable(),
	}).nullable(),
	updatedAt: z.iso.datetime(),
	isGenerated: z.boolean().default(false),
	startedGenerationAt: z.iso.datetime().nullable(),
	finishedGenerationAt: z.iso.datetime().nullable(),
	meta: z.record(z.string(), z.unknown()).nullable(),
})

export type SubmissionThankYouScreenDataSchema = z.infer<typeof submissionThankYouScreenDataSchema>
